function validatePhoneNumber(phoneNumber) {
  let reg = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
  phoneNumber = phoneNumber.replace(/\s/g, ""); //replace all spaces
  return reg.test(phoneNumber);
}
export default validatePhoneNumber;
